/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReImportType } from './ReImportType';
import {
    ReImportTypeFromJSON,
    ReImportTypeFromJSONTyped,
    ReImportTypeToJSON,
    ReImportTypeToJSONTyped,
} from './ReImportType';

/**
 * 
 * @export
 * @interface ReImportMarkerRepresentation
 */
export interface ReImportMarkerRepresentation {
    /**
     * 
     * @type {number}
     * @memberof ReImportMarkerRepresentation
     */
    created: number;
    /**
     * 
     * @type {number}
     * @memberof ReImportMarkerRepresentation
     */
    timeFrom: number;
    /**
     * 
     * @type {number}
     * @memberof ReImportMarkerRepresentation
     */
    timeTo: number;
    /**
     * 
     * @type {string}
     * @memberof ReImportMarkerRepresentation
     */
    generatorKey?: string;
    /**
     * 
     * @type {Array<ReImportType>}
     * @memberof ReImportMarkerRepresentation
     */
    requestedMetricTypes: Array<ReImportType>;
    /**
     * 
     * @type {number}
     * @memberof ReImportMarkerRepresentation
     */
    pendingMetricsCount: number;
}

/**
 * Check if a given object implements the ReImportMarkerRepresentation interface.
 */
export function instanceOfReImportMarkerRepresentation(value: object): value is ReImportMarkerRepresentation {
    if (!('created' in value) || value['created'] === undefined) return false;
    if (!('timeFrom' in value) || value['timeFrom'] === undefined) return false;
    if (!('timeTo' in value) || value['timeTo'] === undefined) return false;
    if (!('requestedMetricTypes' in value) || value['requestedMetricTypes'] === undefined) return false;
    if (!('pendingMetricsCount' in value) || value['pendingMetricsCount'] === undefined) return false;
    return true;
}

export function ReImportMarkerRepresentationFromJSON(json: any): ReImportMarkerRepresentation {
    return ReImportMarkerRepresentationFromJSONTyped(json, false);
}

export function ReImportMarkerRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReImportMarkerRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'created': json['created'],
        'timeFrom': json['timeFrom'],
        'timeTo': json['timeTo'],
        'generatorKey': json['generatorKey'] == null ? undefined : json['generatorKey'],
        'requestedMetricTypes': ((json['requestedMetricTypes'] as Array<any>).map(ReImportTypeFromJSON)),
        'pendingMetricsCount': json['pendingMetricsCount'],
    };
}

export function ReImportMarkerRepresentationToJSON(json: any): ReImportMarkerRepresentation {
    return ReImportMarkerRepresentationToJSONTyped(json, false);
}

export function ReImportMarkerRepresentationToJSONTyped(value?: ReImportMarkerRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'created': value['created'],
        'timeFrom': value['timeFrom'],
        'timeTo': value['timeTo'],
        'generatorKey': value['generatorKey'],
        'requestedMetricTypes': ((value['requestedMetricTypes'] as Array<any>).map(ReImportTypeToJSON)),
        'pendingMetricsCount': value['pendingMetricsCount'],
    };
}

